import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { FormControl } from '@angular/forms';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';

import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';
import { SalesReturnService, SubscribeService } from '../../../services/index';
import { ServiceWalkInModel } from '../../../model/index';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: "machine-return-approval-component",
  templateUrl: "./machineReturnApproval.component.html",
})
export class machineReturnApprovalComponent implements OnInit {
  isLoadMask: Promise<any>;
    serviceWalkInData: ServiceWalkInModel[];
    loadingIndicator: boolean = true;
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'bill_id',
        orderDir: 'asc'
    };
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    bsModalRef: BsModalRef;
    statusCusCtrl: FormControl;
    columns = [];
    toggleCol = [];
    filterData = {
        "search_data": "",
        "from_date": new Date(),
        "to_date": new Date(),
        "user_role_type" : ''
    };
    scrollTimeout: any;
    suppressPaging: boolean = false;
    subscribeAuth;
    showManageButton: boolean;
    branchCtrl: FormControl;
    filteredBranch: Observable<any[]>;
    branchList: any[];
    isLoading: boolean = false;

    constructor(public store: Store<fromRootStore.State>, public toasterService: ToasterService,
        private salesReturnService: SalesReturnService, public subscribeService: SubscribeService,
        private modalService: BsModalService) {
        this.statusCusCtrl = new FormControl();
        this.showManageButton = false;
    }

    ngOnInit(): void {
        let that = this;
        this.branchCtrl = new FormControl();
        this.filteredBranch = this.branchCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBranch(name) : this.branchList.slice());

        this.columns = [
            { name: 'SNo', prop: 'sno', width: 50, minWidth: 50, maxWidth: 50, sortable: false, cellClass: 'cell-center', cellTemplate: this.snoTemplate, toggle: true },
            { name: 'Return No', prop: 'auto_no', width: 100, minWidth: 100, maxWidth: 100, toggle: true },
            { name: 'Return Date', prop: 'disp_return_date', width: 120, minWidth: 120, maxWidth: 120, toggle: true },
            { name: 'Client Name', prop: 'client_name', width: 210, minWidth: 210, maxWidth: 210 },
            { name: 'Client type', prop: 'from_type', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Return to', prop: 'return_to', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Description', prop: 'description', width: 280, minWidth: 280, maxWidth: 280 },
            { name: 'Mobile', prop: 'mobile', width: 150, minWidth: 150, maxWidth: 150, },
            { name: 'Action', prop: 'action', width: 280, minWidth: 280, maxWidth: 280, sortable: false, cellClass: 'cell-left', cellTemplate: this.editDeleteTemplate }
        ];

        this.toggleCol = Object.assign({}, this.columns);
        this.pageCallback({ offset: 0 });

        this.subscribeService.publishReloadClientWalkInGrid().subscribe(($e) => {
            that.pageCallback({ offset: 0 });
        });

        this.subscribeService.publishReloadServiceGrid().subscribe(($e) => {
            that.pageCallback({ offset: 0 });
        })

        this.subscribeAuth = this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin']) {
                this.filterData.user_role_type = auth['user_role_type'];
                if (auth['usertype'] == 'Super_Admin' || auth['usertype'] == 'Admin' || auth['usertype'] == 'Accounts') {
                    this.showManageButton = true;
                }
            }
        });
        //TO LOAD BRANCH COMBO
        this.subscribeAuth.add(this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            this.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' });
        }));
    }
    ngOnDestroy() {
        // prevent memory leak when component destroyed
        //this.subscribeService.publishReloadClientWalkInGrid().unsubscribe();
        if (!_.isEmpty(this.subscribeAuth)) {
            this.subscribeAuth.unsubscribe();
        }
    }
    onOpenedFilter(): void {
        setTimeout(function () {
            $('#filterTextBox').focus();
        }, 100);

    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getSalesReturnList();
    }

    onColumnToggle(colToShow) {
        console.log(colToShow);
        this.columns = colToShow;
    }


    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getSalesReturnList();
        }
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 1000)
    }
    clearFilter(): void {
        this.filterData = {
            "search_data": "",
            "from_date": new Date(),
            "to_date": new Date(),
            "user_role_type" : ''
        };
        this.applyFilter();
    }
    applyFilter(): void {
        //this.filterExpand = false;
        this.filterPanel.close();
        this.getSalesReturnList();
    }

    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList.filter(item => (new RegExp(name, 'gi').test(item.branch_name)));
    }

    displayFn(branchID: any) {
        if (this.branchList != undefined) {
            if (branchID && this.branchList.length > 0) {
                let fitem = _.find(this.branchList, { 'branch_id': branchID });
                return fitem['branch_name'];
            }
        }
        return '';
    }

    displayText(text: string) {
        return text.replace('_', ' ');
    }

    getSalesReturnList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            //filter: JSON.stringify(this.filterData),
            search_data: this.filterData['search_data'],
            from_date: moment(this.filterData['from_date']).format('YYYY-MM-DD'),
            to_date: moment(this.filterData['to_date']).format('YYYY-MM-DD'),
            from_page: this['params']['tabParams'],
            branch_id: this.filterData['branch_id']
        };
        let that = this;
        this.isLoadMask = this.salesReturnService
            .getMachineReturnApprovalList(params)
            .then(function (res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.serviceWalkInData = res.data;
            });
    }

    addEditSalesReturn(mode: string, row: any): void {
        let that = this;
        setTimeout(function () {
            that.filterPanel.close();
        }, 10);

        row['mode'] = mode;
        
        that.subscribeService.subScribeTabID('Transaction', 'AddSalesReturnComponent', Object.assign({}, row), 'Sales Return');

    }

    deleteSalesReturn(row: any): void {

        let that = this,
            data = {
                bill_id: row.bill_id,
                sale_bill_id: row.sale_bill_id,
                client_id: row.client_id,
                salesItemDetails: JSON.stringify(row.data),
                type: row.type
            };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover this Sales Return Details of [' + row['client_no'] + '-' + row['client_name'] + ']',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function () {
            that.isLoadMask = that.salesReturnService
                .deleteSalesReturn(data)
                .then(function (res: any) {
                    that.loadingIndicator = false;
                    if (res.success) {
                        that.getSalesReturnList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });

        }, function (dismiss) {

        })
    }

    saveApproval(row: any, type: string): void {
        let that = this;
        let data = row
        data['status_type'] = type;
        data['stockDet'] = JSON.stringify(row['data']);
        this.isLoading = true;
        this.salesReturnService
        .saveApproval(data)
        .then(function (res: any) {
            that.isLoading = false;
            if (res.success) {
                swal('SUCCESS', res.message, 'success');     
                that.getSalesReturnList();
            } else {
                swal('ERROR', res.message, 'error');
            }
        })
        .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal('ERROR', res.message, 'error');
            //console.log(error);
        });
        
    }

    addStoreStock(row) {
        let that = this,
        data = {
            bill_id: row.bill_id,
            machineDetails: JSON.stringify(row.data)
        };

        swal({
            title: 'Are you sure want to add this to the store stock?',
            showCancelButton: true,
            confirmButtonText: 'Yes, Add!',
            cancelButtonText: 'No, Keep it'
        }).then(function () {
            that.isLoadMask = that.salesReturnService
                .updateStock(data)
                .then(function (res: any) {
                    if (res.success) {
                        that.getSalesReturnList();
                        swal(
                            'Updated',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });

        }, function (dismiss) {

        });
    }

}





// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/salesReturn/machineReturnApproval.component.ts